export interface SearchOrganization {
    id: number;
    name: string;
}

export interface Organization {
    id: number;
    officialName: string;
    isActive: boolean;
    typeCode: string;
    countryCode: string;
    regulationCode?: string;
    regulationCodeType?: string;
    legacyIdentifier: LegacyIdentifier;
    commentHandleId: number;
    messageCount: number;
    globalIdentifier?: number;
    providerCategoryCode?: string;
    supplierCategoryCode?: string;
    isTest: boolean;
    isDemo: boolean;
}

export class LegacyIdentifier {
    logexCode: string;
    mrdmOrganizationId: number;
    coinsLegacyCode: string;
}

export class NlCategoryCode {
    nlHealtcareServiceProviderCategoryCode: string;
    healthcareServiceSupplierCategoryCode: string;
}

export class UkCategoryCode {
    ukHealthcareServiceProviderCategoryCode: string;
    healthcareServiceSupplierCategoryCode: string;
}

export enum LegacyCodes {
    Logex = "logexCode",
    Mrdm = "mrdmOrganizationId",
    Coins = "coinsLegacyCode"
}
